<div class="thp-form-container" id="application-submit-page-container">
  <div class="thp-message">
    <h1 id="application-submit-page-header" class="thp-header">{{ contextText }}</h1>
    <p id="application-submit-page-sub-header" class="thp-sub-header"> {{ "talent-happy-path.initial-interview-questions.application-submit-page.sub-header" | translate }} </p>
  </div>
</div>
<div class="button-container">
  <button mat-flat-button id="application-submit-page-lets-do-this-button" class="custom-button" (click)="clickLetsDoThis()"> {{ "talent-happy-path.buttons.lets-do-this" | translate }} </button>
  <button id="application-submit-page-do-later" *ngIf="showLaterButton" (click)="clickIllDoThisLater()" mat-button class="later-button">
    {{ "talent-happy-path.buttons.do-later" | translate }}
  </button>
</div>
